import { render, staticRenderFns } from "./panel_huifang.vue?vue&type=template&id=6f2e25d8&scoped=true&"
import script from "./panel_huifang.vue?vue&type=script&lang=js&"
export * from "./panel_huifang.vue?vue&type=script&lang=js&"
import style0 from "./panel_huifang.vue?vue&type=style&index=0&id=6f2e25d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2e25d8",
  null
  
)

export default component.exports